import { SnackbarProvider } from 'notistack';
import React from 'react';
import '../styles/snackbar.css';

const SnackBarProvider = ({ children }: React.PropsWithChildren) => {
  return (
    <SnackbarProvider
      maxSnack={2}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      autoHideDuration={5000}
      classes={{
        anchorOriginTopCenter: 'snackbar-top-center',
        containerAnchorOriginTopCenter: 'snackbar-container-top-center',
      }}
    >
      {children}
    </SnackbarProvider>
  );
};

export default SnackBarProvider;
